// import React, { useLayoutEffect, useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import Header from './Layouts/Header';
// import Footer from './Layouts/Footer';
// import { getItemsCategories } from '../utils/apiService';

// const Category = () => {
//     const [categories, setCategories] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchCategories = async () => {
//             setLoading(true);
//             const response = await getItemsCategories();
//             if (response && response.status && response.data) {
//                 setCategories(response.data);
//             }
//             setLoading(false);
//         };

//         fetchCategories();
//     }, []);

//     useLayoutEffect(() => {
//         if (loading) return;

//         // Trigger animations for this section
//         const timer = setTimeout(() => {
//             if (window.animationText) window.animationText();
//             if (window.scrollingEffect) window.scrollingEffect();
//             if (window.animateImgItem) window.animateImgItem();

//             // Refresh ScrollTrigger as content might have changed
//             if (window.ScrollTrigger) {
//                 window.ScrollTrigger.refresh();
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             if (window.revertAnimations) window.revertAnimations();
//             if (window.revertHeadline) window.revertHeadline();
//         };
//     }, [loading, categories]);

//     const getImageUrl = (imgVal) => {
//         if (!imgVal) return '';
//         const imgStr = imgVal.toString().trim();
//         // If it's a full URL, data URI, or already an absolute path (from local imports)
//         if (imgStr.startsWith('http') || imgStr.startsWith('data:') || imgStr.startsWith('/')) {
//             return imgStr;
//         }
//         // Otherwise, assume it's a storage path from the backend
//         return `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
//     };

//     return (
//         <div className="wrapper position-relative">
//             <Header />

//             <div className="page-title">
//                 <div className="tf-container">
//                     <div className="page-title-content text-center">
//                         <h1 className="title">
//                             <span className="split-text effect-right">Category</span>
//                         </h1>
//                         <div className="breadkcum">
//                             <Link to="/" className="link-breadkcum body-2 fw-7">
//                                 <span className="split-text effect-right">Home</span>
//                             </Link>
//                             <span className="dot"></span>
//                             <span className="page-breadkcum body-2 fw-7">
//                                 <span className="split-text effect-right">Categories</span>
//                             </span>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="main-content">
//                 <section className="section-team p-team tf-spacing-2">
//                     <div className="tf-container">
//                         {loading ? (
//                             <div className="text-center">Loading categories...</div>
//                         ) : (
//                             <div className="row rg-30">
//                                 {categories.length > 0 ? (
//                                     categories.map((cat, index) => (
//                                         <div key={index} className="col-lg-3 col-sm-6">
//                                             <div className="team-item product-item hover-image">
//                                                 <div className="top-item">
//                                                     <Link to={`/product-listing`} className="image">
//                                                         <img
//                                                             src={getImageUrl(cat.image)}
//                                                             alt={cat.title}
//                                                             className="ls-is-cached lazyloaded"
//                                                         />
//                                                     </Link>
//                                                     <Link to={`/product-listing`} className="plus-icon">
//                                                         <i className="fa-regular fa-eye"></i>
//                                                     </Link>
//                                                 </div>
//                                                 <div className="item-content">
//                                                     <h6 className="title">
//                                                         <Link to={`/product-listing`}>{cat.title}</Link>
//                                                     </h6>
//                                                     {/* Subtitle is not available in API, omitting or using a default/placeholder if strictly needed, but better to omit */}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div className="col-12 text-center">No categories found.</div>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </section>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default Category;

import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { getItemsCategories } from '../utils/apiService';

const Category = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true);
            const response = await getItemsCategories();
            if (response && response.status && response.data) {
                setCategories(response.data);
            }
            setLoading(false);
        };

        fetchCategories();
    }, []);

    useLayoutEffect(() => {
        if (loading) return;

        // Trigger animations for this section
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            // Refresh ScrollTrigger as content might have changed
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [loading, categories]);

    const getImageUrl = (imgVal) => {
        if (!imgVal) return '';
        const imgStr = imgVal.toString().trim();
        // If it's a full URL, data URI, or already an absolute path (from local imports)
        if (imgStr.startsWith('http') || imgStr.startsWith('data:') || imgStr.startsWith('/')) {
            return imgStr;
        }
        // Otherwise, assume it's a storage path from the backend
        return `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title">
                            <span className="split-text effect-right">Category</span>
                        </h1>
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Home</span>
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Categories</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <section className="section-team p-team tf-spacing-2">
                    <div className="tf-container">
                        {loading ? (
                            <div className="text-center">Loading categories...</div>
                        ) : (
                            <div className="row rg-30">
                                {categories.length > 0 ? (
                                    categories.map((cat, index) => (
                                        <div key={index} className="col-lg-3 col-sm-6">
                                            <div className="team-item product-item hover-image">
                                                <div className="top-item">
                                                    <Link to={`/product-listing/${cat.slug}`} className="image">
                                                        <img
                                                            src={getImageUrl(cat.image)}
                                                            alt={cat.title}
                                                            className="ls-is-cached lazyloaded"
                                                        />
                                                    </Link>
                                                    <Link to={`/product-listing/${cat.slug}`} className="plus-icon">
                                                        <i className="fa-regular fa-eye"></i>
                                                    </Link>
                                                </div>
                                                <div className="item-content">
                                                    <h6 className="title">
                                                        <Link to={`/product-listing/${cat.slug}`}>{cat.title}</Link>
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center">No categories found.</div>
                                )}
                            </div>
                        )}
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Category;